export const getHeatStatus = (heatStatus: string) => {
	switch (heatStatus) {
		case "S":
			return { name: "Scheduled", color: "#0288D1", letter: "S" };
		case "M":
			return { name: "Melting", color: "#FF7043", letter: "M" };
		case "T":
			return { name: "Tapped", color: "#FFD600", letter: "T" };
		case "O":
			return { name: "Opened", color: "#43A047", letter: "O" };
		case "C":
			return { name: "Closed", color: "#607D8B", letter: "C" };
		case "R":
			return { name: "Returned", color: "#8D6E63", letter: "R" };
		case "F":
			return { name: "Finished", color: "#3F51B5", letter: "F" };
		default:
			return { name: "Unknown", color: "#484848", letter: "X" };
	}
};
